import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Divider,
  useTheme,
  useMediaQuery,
  Collapse,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Assessment as ReportsIcon,
  Settings as SettingsIcon,
  Inventory as CatalogoIcon,
  Factory as ProduccionIcon,
  Article as ArticulosIcon,
  Business as ProveedoresIcon,
  Group as AsociacionIcon,
  SetMeal as EspeciesIcon,
  Label as MarcasIcon,
  Description as DERCIcon,
  LocalShipping as GuiasIcon,
  Assignment as PartesIcon,
  Person as DuenioIcon,
  SupervisedUserCircle as EncargadoIcon,
  AccountBalance as PlanillaIcon,
  Badge as TrabajadorIcon,
  ListAlt as ConceptosIcon,
  CalendarMonth as PeriodosIcon,
  TableChart as PlanillonIcon,
  Functions as FormulasIcon,
  CardGiftcard as BeneficiosIcon,
  ExitToApp as LiquidacionIcon,
  BarChart as DashboardPlanillaIcon,
  UploadFile as PLAMEIcon,
  AccessTime as AsistenciaIcon,
  LocalHospital as DescansoMedicoIcon,
  Gavel as DescuentoJudicialIcon,
  Payments as UtilidadesIcon,
  Summarize as ReportesIcon2,
  Tune as ConfigIcon,
  AccountBalanceWallet as AsientosIcon,
  Schedule as TurnosIcon,
  CompareArrows as AfectacionesIcon,
  EventNote as TareoIcon,
  Receipt as HonorariosIcon,
  ViewColumn as CamposIcon,
  FolderShared as GestionIcon,
  PlaylistAddCheck as ProcesosIcon,
  Speed as RendimientoIcon,
  DateRange as AsistenciaGroupIcon,
  AssignmentTurnedIn as ObligacionesIcon,
  Build as ConfigGroupIcon,
  ExpandLess,
  ExpandMore,
  ChevronLeft,
  ChevronRight,
  NotificationsOutlined,
  LightModeOutlined,
  DarkModeOutlined,
  Logout as LogoutIcon,
  AccountCircle as AccountIcon,
  Security as SecurityIcon,
  People as PeopleIcon,
  Shield as ShieldIcon,
  Lock as LockIcon,
  Warehouse as AlmacenesIcon,
  Inventory2 as StockIcon,
  MoveDown as MovInvIcon,
  MenuBook as KardexIcon,
  QrCode as SerialIcon,
  Layers as LoteIcon,
  FactCheck as TomaIcon,
  CallReceived as GuiaEntradaIcon,
  CallMade as GuiaSalidaIcon,
  AccountBalanceWallet as TesoreriaIcon,
  SwapHoriz as MovimientosIcon,
  Search as ExploradorIcon,
  PieChart as DisponibilidadIcon,
  CompareArrows as ConciliacionIcon,
  ReceiptLong as CuentasIcon,
  TrendingUp as FlujoCajaIcon,
  MenuBook as ContabilidadIcon,
  AccountTree as PlanCuentasIcon,
  Settings as ConfigContaIcon,
  DateRange as EjercicioIcon,
  ReceiptLong as VoucherIcon,
  Hub as CentroCostoIcon,
  Assessment as ReportesContaIcon,
  ShoppingBag as ComprasIcon,
  Assignment as SolicitudReqIcon,
  RequestPage as SolicitudCompIcon,
  Description as OrdenCompraIcon,
  ReceiptLong as FactCompraIcon,
  ShoppingCart as VentasIcon,
  PointOfSale as NuevaVentaIcon,
  Restaurant as RestauranteIcon,
  SoupKitchen as CocinaIcon,
  RequestQuote as CotizacionesIcon,
  ListAlt as OrdenesVentaIcon,
  Paid as CobranzaIcon,
  PriceCheck as ListaPrecioIcon,
  NoteAlt as NotaCreditoIcon,
  CloudUpload as ComprobanteElIcon,
  Percent as ComisionesIcon,
  Analytics as ReportesVentasIcon,
} from '@mui/icons-material';
import { useAuth } from '../../auth/hooks/useAuth';
import { usePermissions } from '../../auth/hooks/usePermissions';

const drawerWidth = 240;
const collapsedDrawerWidth = 64;

interface SidebarProps {
  mobileOpen: boolean;
  onMobileToggle: () => void;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
  darkMode: boolean;
  onThemeToggle: () => void;
}

interface MenuItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  path?: string;
  children?: MenuItem[];
  module?: string; // Modulo requerido: CATALOGO, PRODUCCION, SEGURIDAD, REPORTES, SISTEMA
}

const menuItems: MenuItem[] = [
  {
    id: 'planilla',
    label: 'Talento Humano',
    icon: <PlanillaIcon />,
    module: 'PLANILLA',
    children: [
      { id: 'dashboard-planilla', label: 'Dashboard', icon: <DashboardPlanillaIcon />, path: '/planilla/dashboard' },
      {
        id: 'planilla-gestion',
        label: 'Gestión',
        icon: <GestionIcon />,
        children: [
          { id: 'trabajadores', label: 'Trabajadores', icon: <TrabajadorIcon />, path: '/planilla/trabajadores' },
          { id: 'conceptos', label: 'Conceptos', icon: <ConceptosIcon />, path: '/planilla/conceptos' },
          { id: 'periodos', label: 'Periodos', icon: <PeriodosIcon />, path: '/planilla/periodos' },
          { id: 'bases-calculo', label: 'Bases de Cálculo', icon: <FormulasIcon />, path: '/planilla/bases-calculo' },
        ],
      },
      {
        id: 'planilla-procesos',
        label: 'Procesos',
        icon: <ProcesosIcon />,
        children: [
          { id: 'planillon', label: 'Planillon', icon: <PlanillonIcon />, path: '/planilla/planillon' },
          { id: 'beneficios', label: 'Beneficios', icon: <BeneficiosIcon />, path: '/planilla/beneficios' },
          { id: 'liquidacion', label: 'Liquidación', icon: <LiquidacionIcon />, path: '/planilla/liquidacion' },
          { id: 'utilidades', label: 'Utilidades', icon: <UtilidadesIcon />, path: '/planilla/utilidades' },
        ],
      },
      {
        id: 'planilla-asistencia',
        label: 'Asistencia',
        icon: <AsistenciaGroupIcon />,
        children: [
          { id: 'turnos', label: 'Turnos', icon: <TurnosIcon />, path: '/planilla/turnos' },
          { id: 'asistencia', label: 'Asistencia', icon: <AsistenciaIcon />, path: '/planilla/asistencia' },
          { id: 'tareo', label: 'Tareo Diario', icon: <TareoIcon />, path: '/planilla/tareo' },
          { id: 'descanso-medico', label: 'Descanso Médico', icon: <DescansoMedicoIcon />, path: '/planilla/descanso-medico' },
          { id: 'rendimiento', label: 'Asist. Rendimiento', icon: <RendimientoIcon />, path: '/planilla/rendimiento' },
        ],
      },
      {
        id: 'planilla-obligaciones',
        label: 'Obligaciones',
        icon: <ObligacionesIcon />,
        children: [
          { id: 'plame', label: 'PLAME', icon: <PLAMEIcon />, path: '/planilla/plame' },
          { id: 'afectaciones', label: 'Afectaciones', icon: <AfectacionesIcon />, path: '/planilla/afectaciones' },
          { id: 'asientos', label: 'Asientos Contables', icon: <AsientosIcon />, path: '/planilla/asientos' },
          { id: 'descuentos-judiciales', label: 'Dctos. Judiciales', icon: <DescuentoJudicialIcon />, path: '/planilla/descuentos-judiciales' },
        ],
      },
      {
        id: 'planilla-config',
        label: 'Configuración',
        icon: <ConfigGroupIcon />,
        children: [
          { id: 'reportes-avz', label: 'Reportes', icon: <ReportesIcon2 />, path: '/planilla/reportes' },
          { id: 'variables-planilla', label: 'Variables', icon: <ConfigIcon />, path: '/planilla/variables' },
          { id: 'campos-adicionales', label: 'Campos Adicionales', icon: <CamposIcon />, path: '/planilla/campos-adicionales' },
          { id: 'configuracion-planilla', label: 'Configuración', icon: <ConfigIcon />, path: '/planilla/configuracion' },
        ],
      },
    ],
  },
  {
    id: 'seguridad',
    label: 'Seguridad',
    icon: <SecurityIcon />,
    module: 'SEGURIDAD',
    children: [
      { id: 'usuarios', label: 'Usuarios', icon: <PeopleIcon />, path: '/seguridad/usuarios' },
      { id: 'roles', label: 'Roles', icon: <ShieldIcon />, path: '/seguridad/roles' },
      { id: 'permisos', label: 'Permisos', icon: <LockIcon />, path: '/seguridad/permisos' },
    ],
  },
];

const Sidebar: React.FC<SidebarProps> = ({
  mobileOpen,
  onMobileToggle,
  collapsed = false,
  onToggleCollapse,
  darkMode,
  onThemeToggle
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenus, setOpenMenus] = React.useState<Record<string, boolean>>({});
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { user, logout } = useAuth();
  const { permissions, isSuperAdmin } = usePermissions();

  // Debug: mostrar permisos en consola
  React.useEffect(() => {
    console.log('=== DEBUG PERMISOS ===');
    console.log('Usuario:', user?.name, '- Rol:', user?.role);
    console.log('Permisos del token:', permissions);
    console.log('Es SuperAdmin:', isSuperAdmin());
  }, [permissions, user, isSuperAdmin]);

  // Filtrar menu items basado en permisos
  const hasModuleAccess = (module?: string): boolean => {
    // Sin modulo definido = acceso libre (dashboard)
    if (!module) return true;
    // SuperAdmin tiene acceso a todo
    if (isSuperAdmin()) return true;
    // Verificar si tiene algun permiso del modulo
    const hasAccess = permissions.some((p: string) => p.startsWith(module) || p.includes(module));
    console.log(`Módulo ${module}: acceso=${hasAccess}`);
    return hasAccess;
  };

  const filteredMenuItems = menuItems.filter(item => hasModuleAccess(item.module));

  const handleItemClick = (item: MenuItem) => {
    if (item.children) {
      setOpenMenus(prev => ({
        ...prev,
        [item.id]: !prev[item.id]
      }));
    } else if (item.path) {
      navigate(item.path);
      if (isMobile) {
        onMobileToggle();
      }
    }
  };

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await logout();
  };

  const isItemSelected = (item: MenuItem): boolean => {
    if (item.path && location.pathname === item.path) return true;
    if (item.children) {
      return item.children.some(child => isItemSelected(child));
    }
    return false;
  };

  // Auto-open menus based on current path
  React.useEffect(() => {
    const openIds: Record<string, boolean> = {};
    const findActiveMenus = (items: MenuItem[]) => {
      for (const item of items) {
        if (item.children) {
          const hasActive = item.children.some(child => isItemSelected(child));
          if (hasActive) {
            openIds[item.id] = true;
            findActiveMenus(item.children);
          }
        }
      }
    };
    findActiveMenus(menuItems);
    if (Object.keys(openIds).length > 0) {
      setOpenMenus(prev => ({ ...prev, ...openIds }));
    }
  }, [location.pathname]);

  const renderMenuItem = (item: MenuItem, level: number = 0) => (
    <React.Fragment key={item.id}>
      <ListItem disablePadding sx={{ px: collapsed ? 0.5 : 1 }}>
        <ListItemButton
          selected={isItemSelected(item)}
          onClick={() => handleItemClick(item)}
          sx={{
            borderRadius: 2,
            mx: collapsed ? 0.5 : 1,
            mb: 0.5,
            pl: collapsed ? 1 : (1 + level * 2),
            justifyContent: collapsed ? 'center' : 'flex-start',
            '&.Mui-selected': {
              backgroundColor: '#3b82f6',
              '&:hover': {
                backgroundColor: '#2563eb',
              },
            },
            '&:hover': {
              backgroundColor: '#334155',
            },
          }}
        >
          <ListItemIcon sx={{ 
            color: 'inherit', 
            minWidth: collapsed ? 'unset' : 40,
            mr: collapsed ? 0 : undefined,
            justifyContent: 'center'
          }}>
            {item.icon}
          </ListItemIcon>
          {!collapsed && (
            <>
              <ListItemText 
                primary={item.label}
                slotProps={{
                  primary: {
                    fontSize: level === 0 ? '0.875rem' : level === 1 ? '0.8rem' : '0.75rem',
                    fontWeight: item.children ? 600 : (isItemSelected(item) ? 600 : 400),
                  }
                }}
              />
              {item.children && (
                openMenus[item.id] ? <ExpandLess /> : <ExpandMore />
              )}
            </>
          )}
        </ListItemButton>
      </ListItem>
      
      {item.children && !collapsed && (
        <Collapse in={openMenus[item.id]} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map((child) => renderMenuItem(child, level + 1))}
          </List>
        </Collapse>
      )}
    </React.Fragment>
  );

  const drawerContent = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box sx={{ 
        p: collapsed ? 1 : 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'space-between'
      }}>
        {!collapsed && (
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#3b82f6' }}>
              Nuvol
            </Typography>
          </Box>
        )}
        {!isMobile && onToggleCollapse && (
          <IconButton
            onClick={onToggleCollapse}
            size="small"
            sx={{
              color: '#94a3b8',
              '&:hover': {
                backgroundColor: '#334155',
                color: 'white',
              },
            }}
          >
            {collapsed ? <ChevronRight /> : <ChevronLeft />}
          </IconButton>
        )}
      </Box>
      
      <Divider sx={{ borderColor: '#334155' }} />
      
      {/* Menu items */}
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <List sx={{ pt: 2 }}>
          {filteredMenuItems.map((item) => renderMenuItem(item))}
        </List>
      </Box>

      {/* User section */}
      <Box sx={{ mt: 'auto' }}>
        <Divider sx={{ borderColor: '#334155' }} />

        {/* Theme and notifications */}
        <Box sx={{ display: 'flex', justifyContent: collapsed ? 'center' : 'space-around', p: collapsed ? 1 : 2 }}>
          <IconButton
            size="small"
            sx={{ color: '#94a3b8' }}
          >
            <NotificationsOutlined />
          </IconButton>

          <IconButton
            size="small"
            onClick={onThemeToggle}
            sx={{
              color: '#94a3b8',
              '&:hover': {
                color: 'white',
              },
            }}
            aria-label="toggle theme"
          >
            {darkMode ? <LightModeOutlined /> : <DarkModeOutlined />}
          </IconButton>
        </Box>

        {/* User info and menu */}
        <Box sx={{ p: collapsed ? 1 : 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: collapsed ? 0 : 1.5,
              justifyContent: collapsed ? 'center' : 'flex-start',
              cursor: 'pointer',
              borderRadius: 2,
              p: 1,
              '&:hover': {
                backgroundColor: '#334155',
              },
            }}
            onClick={handleMenu}
          >
            <Avatar
              sx={{
                width: collapsed ? 36 : 40,
                height: collapsed ? 36 : 40,
                backgroundColor: '#3b82f6',
                fontSize: '1rem',
              }}
              src={user?.avatar}
            >
              {user?.name?.charAt(0)?.toUpperCase() || 'U'}
            </Avatar>

            {!collapsed && (
              <Box sx={{ textAlign: 'left', flexGrow: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem', color: 'white' }}>
                  {user?.name || 'Usuario'}
                </Typography>
                <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                  {user?.role || 'Sin rol'}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          slotProps={{
            paper: {
              sx: {
                mb: 1,
                minWidth: 200,
              },
            },
          }}
        >
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <AccountIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Perfil</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Configuración</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Cerrar Sesión</ListItemText>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: collapsed ? collapsedDrawerWidth : drawerWidth }, flexShrink: { md: 0 } }}
    >
      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            backgroundColor: '#1e293b',
            color: 'white',
            borderRight: 'none',
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Desktop drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: collapsed ? collapsedDrawerWidth : drawerWidth,
            backgroundColor: '#1e293b',
            color: 'white',
            borderRight: 'none',
            transition: 'width 0.2s ease-in-out',
          },
        }}
        open
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export { drawerWidth, collapsedDrawerWidth };
export default Sidebar;